var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.1764L10.5 14.1764M24.5 7.17643L10.5 7.17643M24.5 21.1764L10.5 21.1764M5.83333 14.1764C5.83333 14.8208 5.311 15.3431 4.66667 15.3431C4.02233 15.3431 3.5 14.8208 3.5 14.1764C3.5 13.5321 4.02233 13.0098 4.66667 13.0098C5.311 13.0098 5.83333 13.5321 5.83333 14.1764ZM5.83333 7.17643C5.83333 7.82076 5.311 8.3431 4.66667 8.3431C4.02233 8.3431 3.5 7.82076 3.5 7.17643C3.5 6.5321 4.02233 6.00977 4.66667 6.00977C5.311 6.00977 5.83333 6.5321 5.83333 7.17643ZM5.83333 21.1764C5.83333 21.8208 5.311 22.3431 4.66667 22.3431C4.02233 22.3431 3.5 21.8208 3.5 21.1764C3.5 20.5321 4.02233 20.0098 4.66667 20.0098C5.311 20.0098 5.83333 20.5321 5.83333 21.1764Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.5fe787622a9797d65f97684b8704eda9.svg";
export { ForwardRef as ReactComponent };